import React, { useEffect, useRef, useState } from "react";
import Modal from "../Modal";
import Form, { Cancel, Checkbox, InputNumber, Label, Radio, Submit, Title, Validation } from "../Form";
import { useDispatch } from "react-redux";
import { get, post } from "../../actions/general";
import { PriceContainer } from "./styles";

const Question = () => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [noSubscription, setNoSubscription] = useState(false);
    const [price, setPrice] = useState("");
    const [bySchool, setBySchool] = useState<null | string>(null);

    const [numberValidation, setNumberValidation] = useState<string | null>(null);
    const [bySchoolValidation, setBySchoolValidation] = useState<string | null>(null);

    const timer = useRef<ReturnType<typeof setTimeout>>();
    const checkToShow = () => {
        dispatch(get("price-question", (res) => {
            if (res.data.canShow) {
                setShow(true);
            }
        }));
    };

    useEffect(() => {
        timer.current = setTimeout(checkToShow, 5000);
        return () => {
            clearTimeout(timer.current);
        }
    }, [])
    useEffect(() => {
        setNumberValidation(null);
        setBySchoolValidation(null);
    }, [price, bySchool])
    const onClose = () => {
        dispatch(post("skip-price-question", {}, () => {
            setShow(false)
        }))
    }
    const onSubmit = () => {
        if (!price || Number.isNaN(Number(price))) {
            return setNumberValidation("Kötelező kitölteni!")
        }
        if (Number(price) < 500) {
            return setNumberValidation("Túl alacsony árat adtál meg!");
        }
        if (Number(price) > 5000) {
            return setNumberValidation("Túl magas árat adtál meg!");
        }

        if (!bySchool) {
            return setBySchoolValidation("Kötelező kitölteni!");
        }
        dispatch(post("price-question", { noSubscription, price: Number(price), bySchool: bySchool === "yes" }, (res) => {
            setShow(false);
        }));
    }
    if (!show) {
        return null;
    }
    return (
        <Modal close={onClose} >
            <Title>Kérdés</Title>
            <Form>

                <Label>
                    <span style={{ fontSize: 18 }}>
                        Ha elő kellene fizetned a Musicators használatára, havonta mekkora összeget tudnál rá szánni?
                    </span>
                </Label>
                {numberValidation && (
                    <Validation plainText={numberValidation} />
                )}
                <PriceContainer>
                    <InputNumber value={price} onChange={e => setPrice(e.currentTarget.value)} name="price" />
                    <span style={{ display: "block", marginTop: 10}}>
                        Ft / hónap
                    </span>
                </PriceContainer>
                <Checkbox label="Nem fizetnék elő" checked={noSubscription} onChange={(e) => setNoSubscription(e.target.checked)} />
                <Label>
                    <span style={{ fontSize: 18 }}>
                        Az intézményed képes lenne átvállalni a költséget?
                    </span>
                </Label>
                {bySchoolValidation && (
                    <Validation plainText={bySchoolValidation} />
                )}
                <Radio value={bySchool} onChange={e => setBySchool(e.target.value)} options={[{ label: "Igen", value: "yes" }, { label: "Nem, én fizetném", value: "no" }]} />
                <Submit onClick={onSubmit}>Beküld</Submit>
                <Cancel onClick={onClose}>Bezár</Cancel>
            </Form>

        </Modal>
    );
};

export default Question;
